/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { DebugSendCompletionEmailOptions, DebugSendCompletionEmailResponses } from '../../models/DebugSendCompletionEmail'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Queue a course completion certificate email for a given user and course.
 * @summary Send Completion Email
 * {@link /admin/debug/send-completion-email}
 */
export function debugSendCompletionEmail<ThrowOnError extends boolean = true>(options: Options<DebugSendCompletionEmailOptions, ThrowOnError>): Promise<UnwrappedResult<DebugSendCompletionEmailResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/debug/send-completion-email', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<DebugSendCompletionEmailResponses, ThrowOnError>>
}
